/** The earnings tiles and work record in Records, from jobs signed on GigSync, and the worker's money actions inside a job. */
export const money = {
    "passbook.week": "Received this week",
    "passbook.month": "Received this month",
    "passbook.not_asked": "Not asked for yet",
    "passbook.empty": "Jobs you complete on GigSync, and the money from them, show here.",
    "passbook.about": "Each line is a job you and the customer both signed. It stays on this phone.",
    "money.ask_again": "Ask for payment again",
    "money.ask_month": "Ask for this month's payment",
    "money.show_qr": "Show my QR",
    "money.hide_qr": "Hide QR",
    "money.cash_confirm": "Record {price} received in cash?",
    "money.need_upi": "Add the UPI ID customers pay you on, in About me.",
    "money.add_upi": "Add UPI ID",
    "money.nudge": "Add your UPI ID before this job ends, so the customer can pay you straight away.",
    "money.waiting": "Waiting for {name} to pay {price}.",
    "money.asked_at": "Asked {time}",
    "money.already_in_bank": "It's already in my bank",
    "money.bank_confirm": "Mark {price} as received?",
};
//# sourceMappingURL=money.js.map